import { render, staticRenderFns } from "./DashboardSale.vue?vue&type=template&id=5532c76c&scoped=true&"
import script from "./DashboardSale.vue?vue&type=script&lang=js&"
export * from "./DashboardSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5532c76c",
  null
  
)

export default component.exports